import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=ceaf8a94&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=js"
export * from "./ResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=ceaf8a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaf8a94",
  null
  
)

export default component.exports